export const TeamGetters = {
  teams: state => state.teams,
}
